import React, { useState, useEffect } from "react";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import { useParams, useHistory, useLocation } from "react-router-dom";
import { Auth, API } from "aws-amplify";
import LoaderButton from "../components/LoaderButton";
import { useAppContext } from "../libs/contextLib";
import { useFormFields } from "../libs/hooksLib";
import { onError } from "../libs/errorLib";
import PrivacyPolicyForm from "./PrivacyPolicyForm";
import AdministrativeAttrsConfirm from "./AdministrativeAttrsConfirm";
import RegistrationInfoForm from "./RegistrationInfoForm";
import RegistrationInfoConfirm from "./RegistrationInfoConfirm";
import AffiliationInfoForm from "./AffiliationInfoForm";
import AffiliationInfoConfirm from "./AffiliationInfoConfirm";
import HomeInfoForm from "./HomeInfoForm";
import HomeInfoConfirm from "./HomeInfoConfirm";
import BasicDomainInfoForm from "./BasicDomainInfoForm";
import BasicDomainInfoConfirm from "./BasicDomainInfoConfirm";
import AcademicHistoryInfoForm from "./AcademicHistoryInfoForm";
import AcademicHistoryInfoConfirm from "./AcademicHistoryInfoConfirm";
import CertificationInfoForm from "./CertificationInfoForm";
import CertificationInfoConfirm from "./CertificationInfoConfirm";
import CertificationInfo2Form from "./CertificationInfo2Form";
import CertificationInfo2ConfirmV2 from "./CertificationInfo2ConfirmV2";
import RecommendersInfoConfirm from "./RecommendersInfoConfirm";
import RecommendersInfo2Confirm from "./RecommendersInfo2Confirm";
import RecommendersInfoForm from "./RecommendersInfoForm";
import RecommendersInfo2Form from "./RecommendersInfo2Form";
import OthersInfoForm from "./OthersInfoForm";
import OthersInfoConfirm from "./OthersInfoConfirm";
import MembersInfo from "./MembersInfo";
import "./ViewMembers.css";

export default function Signup(props) {
  const { id } = useParams();
  const [ member, setMember ] = useState(null);
  const [ isInitialLoading, setIsInitialLoading ] = useState(true);
  const [refreshCount, setRefreshCount] = useState(0);
  const search = useLocation().search;
  const opt = new URLSearchParams(search).get('opt');
  const [opType, setOpType] = useState(opt ? opt : 1);

  let amd = new URLSearchParams(search).get('amd');
  amd = amd ? amd : 'no'; // admin mode (no: general, req : request, mgmt: management)

  useEffect(() => {
    console.log('useEffect called...');
    console.log('opType = ' + opType);
    const onLoad = async () => {
      console.log('onLoad called...');
      const anonymousUser = await Auth.currentCredentials();
      try {
        const m = await loadMember();
        console.log(m);
        setMemberTypeLabel(m.memType == 1 || m.memType == 2 || m.memType == 3 ? '正会員' : (m.memType == 4 || m.memType == 5 || m.memType == 6 ? '准会員' : (m.memType == 7 || m.memType == 8 ? '正会員（准会員から移行）' : '会員')));
        setLabelSubstring(m.memType == 1 || m.memType == 2 || m.memType == 3 ? '（医師・歯科医師用）' : '');
        setMemType(m.memType);
        let ymd = m.birthDate.split('-');
        m.birthY = ymd[0];
        m.birthM = ymd[1];
        m.birthD = ymd[2];
        ymd = m.certifiedDate.split('-');
        m.certifiedY = ymd[0];
        m.certifiedM = ymd[1];
        m.certifiedD = ymd[2];
        ymd = m.acquiredDate.split('-');
        m.acquiredY = ymd[0];
        m.acquiredM = ymd[1];
        m.acquiredD = ymd[2];
        setCertifiedEra(m.certifiedEra);
        setCert1Checks(m.cert1Checks);
        setAcquiredEra(m.acquiredEra);
        setCert2Checks(m.cert2Checks);
        setMember(m);
      } catch(e) {
        onError(e);
      }
    };
    onLoad();
    setIsInitialLoading(false);
  },[]);

  // memStatus (Member Status) radio
  const [memStatus, setMemStatus] = useState(0);
  // memType (Member Type) radio
  const [memType, setMemType] = useState(0);
  // memClass (Member Classification) radio
  const [memClass, setMemClass] = useState(0);
  // memPost (Member Post) checkbox
  const [memPost, setMemPost] = useState([0,0,0,0,0]);
  // memCommittee (Member Committee) checkbox
  const [memCommittee, setMemCommittee] = useState([0,0,0,0,0,0,0,0,0,0]);
  // memRepresentative (Member Representative) checkbox
  const [memRepresentative, setMemRepresentative] = useState([0]);

  // gender radio
  const [gender, setGender] = useState(0);
  const [genderMessage, setGenderMessage] = useState('');
  // birthEra radio
  const [birthEra, setBirthEra] = useState(0);
  const [birthEraMessage, setBirthEraMessage] = useState('');
  // destination radio
  const [destination, setDestination] = useState(0);
  const [destinationMessage, setDestinationMessage] = useState('');
  // graduate radio
  const [graduate, setGraduate] = useState(0);
  const [graduateMessage, setGraduateMessage] = useState('');
  // graduateEra radio
  const [graduateEra, setGraduateEra] = useState(0);
  const [graduateEraMessage, setGraduateEraMessage] = useState('');
  // certifiedEra radio
  const [certifiedEra, setCertifiedEra] = useState(0);
  const [certifiedEraMessage, setCertifiedEraMessage] = useState('');
  // acquiredEra radio
  const [acquiredEra, setAcquiredEra] = useState(0);
  const [acquiredEraMessage, setAcquiredEraMessage] = useState('');

  // cert1 checkbox
  const [cert1Checks, setCert1Checks] = useState([0,0,0,0,0]);
  // cert2 checkbox
    const [cert2Checks, setCert2Checks] = useState([0,0,0,0,0,0,0,0,0,0,0,0,0,0,0]);

  const [birthYMDMessage, setBirthYMDMessage] = useState('');
  const [certifiedYMDMessage, setCertifiedYMDMessage] = useState('');
  const [acquiredYMDMessage, setAcquiredYMDMessage] = useState('');
  const [cert1ChecksMessage, setCert1ChecksMessage] = useState('');
  const [cert2ChecksMessage, setCert2ChecksMessage] = useState('');

  const history = useHistory();
  const [newUser, setNewUser] = useState(null);
  const { userHasAuthenticated, isAdmin} = useAppContext();
  const [isLoading, setIsLoading] = useState(false);
  const [page, setPage] = useState("pp"); // Privacy Policy as default

  const [memberTypeLabel, setMemberTypeLabel] = useState("");
  const [labelSubstring, setLabelSubstring] = useState('');
//  const [isMemberLoaded, setIsMemberLoaded] = useState(false);

  const getTitleLabel = () => {
      return (amd === 'mgmt' ? `${memberTypeLabel}情報` : (amd == 'transfer' ? '申請 准会員から正会員' : (memType == 7 ? '申請情報 准会員から正会員' : `入会 ${memberTypeLabel}申込み${labelSubstring}情報`)));
  };

  function loadMember() {
    return API.get("sakurajima", `/members/${id}`); 
  }

  const back = (event) => { 
    console.log(event.target.id);
    history.push(amd == 'mgmt' ? '/admin/memberships' : `/admin`);
  };

  function handleDummySubmit(event) {
  }

  function renderView() {
      return ( 
      <>
        <div id="registration" className="confirm">
          <section>
             {  administrativeAttrsConfirm }
            <RegistrationInfoConfirm 
              gender={member.gender} birthEra={member.birthEra}
              destination={member.destination}
              viewMode={true} member={ member }
            />
            <AffiliationInfoConfirm
              viewMode={true}
              member={ member }
              mt={ member.memType }
            />
            <HomeInfoConfirm
              viewMode={true} member={ member }
            />
            { basicDomainInfoConfirm }
            <AcademicHistoryInfoConfirm
              graduate={graduate} 
              graduateEra={graduateEra} 
              viewMode={true} member={ member }  mt={memType}
            />
            { certificationInfoConfirm }
            { certificationInfo2Confirm }
            {recommendersInfoConfirm}
            {recommendersInfo2Confirm}
            {othersInfoConfirm}
        <Form onSubmit={handleDummySubmit}>
        <div className="btn">
          <Button id="prev" active size="lg" active onClick={ back } >
            戻る
          </Button>
        </div>
        </Form>
          </section>
        </div>
      </>
      );
  }

  const administrativeAttrsConfirm = isAdmin ? <AdministrativeAttrsConfirm amd={amd} viewMode={true} member={ member } /> : <></>;
  const basicDomainInfoConfirm = memType == 1 || memType == 2 || memType == 3 ? <BasicDomainInfoConfirm viewMode={true} member={ member } /> : <></>;
  const certificationInfoConfirm = memType == 1 || memType == 2 || memType == 3 ? <CertificationInfoConfirm  
                                     certifiedEra={certifiedEra} cert1Checks={cert1Checks}
                                     viewMode={true} member={ member } 
        /> : <></>;
  const certificationInfo2Confirm = memType == 4 || memType == 5 || memType == 6 || memType == 8 ? <CertificationInfo2ConfirmV2 amd={amd}
                                     acquiredEra={acquiredEra} cert2Checks={cert2Checks}
                                     viewMode={true} member={ member } 
        /> : <></>;
  const recommendersInfoConfirm =  member && !(member.memType == 4 || member.memType == 5 || member.memType == 6 || member.memType == 10 || member.memType == 14 || member.memType == 15 || member.memType == 16 || member.memType == 17 || member.memType == 8) ? <></> : <RecommendersInfoConfirm viewMode={true} member={ member } />;
  const recommendersInfo2Confirm = member && ((member.memType == 1 || member.memType == 2 || member.memType == 3 || member.memType == 4 || member.memType == 5 || member.memType == 6 || member.memType == 10) || (memType == 14 || memType == 15 ||  memType == 16 || memType == 17)) ? <></> : <RecommendersInfo2Confirm viewMode={true} member={ member } />;

  const othersInfoConfirm =  member && (member.memType == 1 || member.memType == 2 || member.memType == 3) ? <></> : <OthersInfoConfirm  viewMode={true} member={ member } />;

  return member && ( 
    <div className="ViewMembers">
      <main>
      <h1 id="page_title">{ getTitleLabel() }</h1>
      <div className="container">
        <div id="sub_page">
          { member !== null && renderView() }
        </div>
      </div>
      </main>
    </div>
  );
}
